import { DriveStep } from 'driver.js';
import type { TFunction } from 'i18next';

export const createResultsTourSteps = (t: TFunction): DriveStep[] => [
  {
    element: '[data-tour="results-structure"]',
    popover: {
      title: t('onboarding.results.structure_title', 'Соответствие структуре'),
      description: t(
        'onboarding.results.structure_desc',
        'ИИ оценил структуру презентации под выбранную цель.',
      ),
    },
  },
  {
    element: '[data-tour="results-analysis"]',
    popover: {
      title: t('onboarding.results.analysis_title', 'Анализ презентации'),
      description: t(
        'onboarding.results.analysis_desc',
        'Разбор содержания: логика, аргументация, текстовая нагрузка слайдов.',
      ),
    },
  },
  {
    element: '[data-tour="results-recommendations"]',
    popover: {
      title: t('onboarding.results.recommendations_title', 'Рекомендации'),
      description: t(
        'onboarding.results.recommendations_desc',
        'Конкретные советы по улучшению презентации.',
      ),
    },
  },
  {
    element: '[data-tour="results-generate-speech"]',
    popover: {
      title: t('onboarding.results.generate_title', 'Сгенерировать речь'),
      description: t(
        'onboarding.results.generate_desc',
        'Нажмите, чтобы создать текст выступления по слайдам для тренировки.',
      ),
    },
  },
];
